export default __webpack_public_path__ + "static/media/ic-cc-3.49bd7c81.svg";